import { Component, Input } from '@angular/core';
import { Address } from '@models/address';
import {
	AssociatedContactType,
	BusinessClient,
	ClientType,
} from '@models/clients';
import { SalutationOptionType } from '@models/matter';
import { ClientsDispatch } from '@state/clients';
import { YES_NO_OPTIONS } from 'src/app/ui/utils/constants';
import { TestHooks } from './business-details.hooks';

@Component({
	selector: 'app-client-business-details',
	templateUrl: './business-details.component.html',
	styleUrls: ['./business-details.component.scss'],
	standalone: false,
})
export class ClientBusinessDetailsComponent {
	testHooks = TestHooks;
	public _client: BusinessClient;
	public clientTypes = ClientType;

	public associateTypes = AssociatedContactType;
	public salutationTypes = SalutationOptionType;
	public primarySalutation = '';
	public envelopeSalutation = '';

	public yesNoOptions = YES_NO_OPTIONS;

	@Input() set client(client: BusinessClient) {
		this._client = client;
	}

	constructor(private clientsDispatch: ClientsDispatch) {}

	setServiceAddress = (serviceAddress: Address) => {
		this.clientsDispatch.CreateOrMerge(this._client.id, { serviceAddress });
	};

	onNameChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'name',
			event,
		);
	};

	onTypeChanged = (event: ClientType.CORPORATION | ClientType.BUILDER) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'type',
			event,
		);
	};

	onCanadianCompanyChange = (event: boolean) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'canadianCompany',
			event,
		);
	};

	onJurisdictionChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'jurisdiction',
			event,
		);
	};

	onCorporationNumberChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'corporationNumber',
			event,
		);
	};

	onDateOfIncorporationChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'dateOfIncorporation',
			event,
		);
	};

	onProvinceOfIncorporationChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'provinceOfIncorporation',
			event,
		);
	};

	onRecordSourceChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'recordSource',
			event,
		);
	};

	onBusinessActivityChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'businessActivity',
			event,
		);
	};

	onPhoneChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'phone',
			event,
		);
	};

	onFaxChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'fax',
			event,
		);
	};

	onEmailChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'email',
			event,
		);
	};

	onReLineChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'reLine',
			event,
		);
	};

	onPrimarySalutationTypeChanged = (event: SalutationOptionType) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'primarySalutationOption',
			event,
		);
	};

	onPrimarySalutationChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'customPrimarySalutation',
			event,
		);
	};

	onEnvelopeSalutationTypeChanged = (event: SalutationOptionType) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'envelopeSalutationOption',
			event,
		);
	};

	onEnvelopeSalutationChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'customEnvelopeSalutation',
			event,
		);
	};

	onEnvelopeSalutationContChanged = (event: string) => {
		this.clientsDispatch.OverwriteBusinessClientFields(
			this._client.id,
			'envelopeSalutationContd',
			event,
		);
	};
}
